module.exports = __webpack_public_path__ + "img/product-2.1d7c4431.png";